import { get_token, get_user_details } from "@/router";
import Swal from "sweetalert2";
import Discussion from "@/components/DiscussionForum/DiscussionForum.vue";
import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';

import { client_domain } from "@/main.js";

export default {
    props: {
        is_public: {
            type: Boolean,
            default: false,
        },
        portal_admin: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        Discussion,
        Sidebar,
        Navbar,
        InactivityModal,
    },
    mounted() {
        this.token_exists = get_token();
        this.user_id = this.get_user_id();
        this.user_details = get_user_details();
        this.get_question_types();
        this.filter_polls();

        this.fetch_questions();

        if (client_domain.includes('soulcity') || client_domain.includes('nsp')) {
            this.soulcity_domain = true;
        }
    },

    data() {

        return ({
            selectedPollId: null,
            token_exists: false,
            polls: [],
            activeVoiceTab: 'discussions',
            poll_name: '',
            poll_description: '',
            questions: [],
            showQuestionsForm: true,
            errors: [],
            answers: {},
            filteredQuestions: [],
            poll_poll_selectname: "",
            selectedQuestions: [],
            description: "",
            showQuestionForm: false,
            newQuestion: {
                text: '',
                question_number: '',
                type: '',
                options: [],
                is_mandatory: false,
            },
            question_types: [],
            showSelectedQuestions: false,
            createdQuestions: [],
            poll_questions: [],
            portal_id: null,
            expandedQuestions: new Map(),
            allowMultiple: false,
            options: [
                { value: '' },
                { value: '' },
                { value: '' }
            ],
            selectedPoll: null,
            numberErrors: {},
            soulcity_domain: false,
            user_details: {
                "user_role": '',
                "user_id": '',
            },
            openOptions: new Map(),
            flipped_id: null,
            isEditMode: false,

        })
    },
    methods: {
    open_create_modal() {
      this.isEditMode = false;
    //   this.resetPortalForm();
      $('#create_poll').modal('show');
    },
    open_edit_modal(poll) {
      this.isEditMode = true;
      this.poll_name = poll.name;
      this.description = poll.description;
      $('#create_poll').modal('show');
    },
        getToken() {
            return get_token();
        },

        get_user_id() {
            const user_id = localStorage.getItem('user_id') || '';
            return user_id;
        },

        filter_polls() {

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/filter_poll/`,
                method: 'POST',
                headers: {
                    'Authorization': `Token ${this.getToken()}`,
                    'Content-Type': 'application/json'
                },
                success: (response) => {
                    this.polls = response.data;
                },
                complete: () => {
                    this.isLoading = false;
                }
            });
        },

        fetch_questions() {
            this.token_exists = get_token();
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_questions/`,
                method: "POST",
                headers: this.token_exists
                    ? { Authorization: `Token ${this.getToken()}` }
                    : {},
                success: (response) => {
                    this.questions = response.data.questions;
                },
            });
        },

                validation_for_poll_name() {
                    this.errors = {};
                    let valid = true;
                    if (!this.poll_name || this.poll_name.trim() === '') {
                        this.errors.poll_name = 'Poll name is required';
                        valid = false;
                    }
                    if (!this.poll_question || this.poll_question.trim() === '') {
                        this.errors.poll_question = 'A question is required';
                        valid = false;
                    }
                    const hasAtLeastOneAnswer = this.options.some(
                        option => option.value && option.value.trim() !== ''
                    );
                    if (!hasAtLeastOneAnswer) {
                        this.errors.poll_answer = 'At least one answer option is required';
                        valid = false;
                    }
                    return valid;
                },
                submit_poll_form() {
                    if (!this.validation_for_poll_name()) {
                        return;
                    }
                    const answers = this.options
                        .map((option, index) => ({ text: option.value?.trim(), order: index + 1 }))
                        .filter(answer => answer.text);

                    const payload = {
                        poll_name: this.poll_name,
                        ...(this.$route.params.portal_id ? { portal_id: Number(this.$route.params.portal_id) } : {}),
                        questions: [
                            {
                                question_text: this.poll_question,
                                question_type: this.allowMultiple ? "selection" : "checkbox",
                                options: answers
                            }
                        ]
                    };

                    $.ajax({
                        url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/create_poll/`,
                        method: "POST",
                        headers: {
                            Authorization: `Token ${this.getToken()}`,
                            "Content-Type": "application/json"
                        },
                        data: JSON.stringify(payload),
                        success: () => {
                            Swal.fire({
                                title: 'Creating poll...',
                                allowOutsideClick: false,
                                didOpen: () => {
                                    Swal.showLoading();
                                }
                            });
                            Swal.close();

                            this.filter_polls();
                            Swal.fire({
                                icon: 'success',
                                title: 'Poll Created',
                                text: 'Your poll has been successfully created!',
                                showConfirmButton: false,
                                timer: 2000,
                                position: 'bottom-end',
                                toast: true
                            }).then(() => {
                                this.reset_poll_form();
                                this.activeVoiceTab = 'polls';
                                $('#create_poll').modal('hide');
                            });
                        },

                        error: (xhr) => {
                            Swal.close();

                            this.errors.poll_name = xhr.responseJSON.message

                        }
                    });
                },

                reset_poll_form() {
            this.poll_name = "";
            this.poll_question = "";
            this.poll_description = "";
            this.allowMultiple = false;
            this.options = [{ value: "" }, { value: "" }, { value: "" }];
        },

        update_poll() {
            this.poll_description = this.$refs.quillPollEditorRef.getHTML();

            this.poll_description = this.poll_description.replace(/<\/?p>/g, '').trim();

            if (!this.poll_description || this.poll_description === '<br>' || this.poll_description === '<br/>') {
                this.poll_description = '';
            }

            if (this.newQuestion.text && this.newQuestion.type) {

                this.add_question_to_poll()
                    .then(() => {
                        this.update_poll_form();
                    })
                    .catch((error) => {
                        console.error("Error adding question:", error);
                    });
                return;
            }
            this.update_poll_form();
        },
        update_poll_form() {
                    const questionType = this.question_types.find(question_type =>
                        question_type.question_type.toLowerCase() === (this.allowMultiple ? 'selection' : 'checkbox')
                    );
                    const question_type_id = questionType?.id || null;

                    const answers = this.options
                        .map(option => option.value?.trim())
                        .filter(Boolean);

                    const payload = {
                        poll_id: this.poll_id,
                        name: this.poll_name,
                        description: this.poll_description || '',
                        questions: [
                            {
                                question: this.poll_question,
                                question_type: question_type_id,
                                question_number: 1,
                                is_mandatory: false,
                                options: answers
                            }
                        ]
                    };

                    Swal.fire({
                        title: 'Updating poll...',
                        allowOutsideClick: false,
                        didOpen: () => Swal.showLoading()
                    });

                    $.ajax({
                        url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/update_poll/`,
                        method: "POST",
                        headers: {
                            Authorization: `Token ${this.getToken()}`,
                            "Content-Type": "application/json"
                        },
                        data: JSON.stringify(payload),
                        success: () => {
                            this.filter_polls();
                            Swal.fire({
                                icon: 'success',
                                title: 'Poll Updated',
                                text: 'Your poll has been successfully updated!',
                                showConfirmButton: false,
                                timer: 2000,
                                position: 'bottom-end',
                                toast: true
                            }).then(() => {
                                this.reset_poll_form();
                                this.activeVoiceTab = 'polls';
                            });
                        },
                        error: (xhr) => {
                            Swal.fire({
                                icon: 'error',
                                title: 'Cannot Edit Poll',
                                text: xhr.responseJSON?.message || 'Poll already answered or invalid data.',
                                position: 'bottom-end',
                                showConfirmButton: false,
                                timer: 3000,
                                toast: true
                            });
                        }
                    });
                },
        get_question_types() {
            this.token_exists = get_token();
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/get_question_types/`,
                method: "GET",
                headers: { Authorization: `Token ${this.getToken()}` },
                success: (response) => {
                    this.question_types = response.data.question_types;
                },
            });
        },
        add_question_to_poll() {
            return new Promise((resolve, reject) => {
                if (!this.newQuestion.text || !this.newQuestion.type || !this.newQuestion.question_number) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Missing Information',
                        text: 'Please fill in all required fields for the question',
                        position: 'bottom-end',
                        showConfirmButton: false,
                        timer: 3000,
                        toast: true
                    });
                    reject('Missing required fields');
                    return;
                }

                // Check if the question already exists
                const existingQuestion = this.questions.find(q => q.question === this.newQuestion.text);
                if (existingQuestion) {
                    if (!this.selectedQuestions.some(q => q.id === existingQuestion.id)) {
                        this.selectedQuestions.push(existingQuestion);
                        this.createdQuestions.push({
                            text: existingQuestion.question,
                            id: existingQuestion.id,
                            type: existingQuestion.question_type.id,
                            is_mandatory: existingQuestion.is_mandatory || false,
                        });
                    }
                    this.newQuestion = {
                        text: '',
                        question_number: '',
                        type: '',
                        options: [],
                        is_mandatory: false,
                    };

                    Swal.fire({
                        icon: 'success',
                        title: 'Question Added',
                        text: 'Existing question has been added to your poll',
                        showConfirmButton: false,
                        timer: 1500,
                        position: 'bottom-end',
                        toast: true
                    });

                    resolve();
                } else {
                    // Create a new question via API
                    const formData = new FormData();
                    formData.append('question', this.newQuestion.text);
                    formData.append('question_type', this.newQuestion.type);
                    formData.append('question_number', this.newQuestion.question_number);
                    formData.append('is_mandatory', this.newQuestion.is_mandatory);

                    // Add options if any
                    if (this.newQuestion.options && this.newQuestion.options.length > 0) {
                        this.newQuestion.options.forEach(option => {
                            if (option.text && option.text.trim() !== "") {
                                formData.append('options', option.text.trim());
                            }
                        });
                    }

                    Swal.fire({
                        title: 'Creating question...',
                        allowOutsideClick: false,
                        didOpen: () => {
                            Swal.showLoading();
                        }
                    });

                    $.ajax({
                        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/create_question/`,
                        method: "POST",
                        headers: { Authorization: `Token ${this.getToken()}` },
                        data: formData,
                        processData: false,
                        contentType: false,
                        success: (response) => {
                            if (response.status === "success") {
                                const newQuestion = response.question_data;

                                // Add to selected questions
                                if (newQuestion && newQuestion.id) {
                                    this.selectedQuestions.push({
                                        id: newQuestion.id,
                                        question: newQuestion.question
                                    });

                                    // Add to created questions list for display
                                    this.createdQuestions.push({
                                        text: newQuestion.question,
                                        id: newQuestion.id,
                                        type: newQuestion.question_type.id,
                                        is_mandatory: newQuestion.is_mandatory || false,
                                    });

                                    // Show success message
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Question Created',
                                        text: 'New question has been created and added to your poll',
                                        showConfirmButton: false,
                                        timer: 1500,
                                        position: 'bottom-end',
                                        toast: true
                                    });

                                    // Reset the form for the next question
                                    this.newQuestion = {
                                        text: '',
                                        question_number: '',
                                        type: '',
                                        options: [],
                                        is_mandatory: false,
                                    };

                                    // Refresh questions list
                                    this.fetch_questions();

                                    // Resolve the promise with the new question
                                    resolve(newQuestion);
                                } else {
                                    Swal.fire({
                                        icon: 'warning',
                                        title: 'Question Created',
                                        text: 'Question was created but could not be added to poll. Please try again.',
                                        position: 'bottom-end',
                                        showConfirmButton: false,
                                        timer: 3000,
                                        toast: true
                                    });
                                    reject('Question created but missing ID');
                                }
                            } else {
                                reject('Failed to create question');
                            }
                        },
                        error: () => {
                            Swal.fire({
                                icon: 'error',
                                title: 'Error',
                                text: 'Failed to create question on poll.',
                                showConfirmButton: false,
                                timer: 1500,
                                position: 'bottom-end',
                                toast: true
                            });
                            reject('Failed to create question');
                        }
                    });
                }
            });
        },
        delete_poll(poll_id) {
            Swal.fire({
                title: 'Are you sure?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                position: 'bottom-end',
                toast: true
            }).then((result) => {
                if (result.isConfirmed) {
                    $.ajax({
                        type: "DELETE",
                        url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/delete_poll/`,
                        data: JSON.stringify({ poll_id: poll_id }),
                        headers: {
                            'Authorization': `Token ${this.getToken()}`,
                            'Content-Type': 'application/json'
                        },
                        success: (response) => {
                            const status = response.status;
                            if (status === "success") {
                                this.polls = this.polls.filter(poll => poll.id !== poll_id);
                                Swal.fire({
                                    title: 'Deleted!',
                                    text: 'The poll has been deleted.',
                                    icon: 'success',
                                    showConfirmButton: false,
                                    timer: 1000,
                                    position: 'bottom-end',
                                    toast: true
                                })
                            } else {
                                Swal.fire({
                                  title: 'Failed!',
                                  text: response.message || 'An error occurred. Please try again.',
                                  icon: 'error',
                                  position: 'bottom-end',
                                  showConfirmButton: false,
                                  timer: 3000,
                                  toast: true
                                });
                            }
                        },
                        error: (xhr) => {
                            Swal.fire({
                              title: 'Failed!',
                              text: xhr.responseJSON?.message || 'An error occurred. Please try again.',
                              icon: 'error',
                              position: 'bottom-end',
                              showConfirmButton: false,
                              timer: 3000,
                              toast: true
                            });
                        }
                    });
                }
            });
        },



    }
};